import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const COUNTRIES = [
  { slug: "germany", name: "Germany", flag: "🇩🇪", note: "Engineering · SAP · Fintech", hubs: "Berlin · Munich · Frankfurt" },
  { slug: "netherlands", name: "Netherlands", flag: "🇳🇱", note: "Cloud · Data · Cybersecurity", hubs: "Amsterdam · Rotterdam · Eindhoven" },
  { slug: "romania", name: "Romania", flag: "🇷🇴", note: "Nearshore · Full-stack · QA", hubs: "Bucharest · Cluj · Iași" },
  { slug: "poland", name: "Poland", flag: "🇵🇱", note: "Java · Cloud · DevOps", hubs: "Warsaw · Kraków · Wrocław" },
  { slug: "bulgaria", name: "Bulgaria", flag: "🇧🇬", note: "Embedded · Python · Frontend", hubs: "Sofia · Plovdiv · Varna" },
  { slug: "remote-europe", name: "Remote Europe", flag: "🌍", note: "Senior · Distributed · Contract", hubs: "20+ EU/EEA countries" },
];

export default function CountryHubs() {
  return (
    <section
      id="locations"
      data-testid="country-hubs"
      className="py-20 lg:py-28 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
              Locations
            </div>
            <h2 className="font-display font-bold mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
              On the ground in 6 European markets.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            Dedicated country leads. Local labour-law expertise. EU contracts,
            payroll, and relocation when needed.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {COUNTRIES.map((c) => (
            <Link
              key={c.slug}
              to={`/locations/${c.slug}`}
              data-testid={`country-card-${c.slug}`}
              className="group rounded-2xl border border-slate-200 bg-white p-6 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 flex flex-col justify-between min-h-[180px]"
            >
              <div>
                <div className="text-3xl">{c.flag}</div>
                <h3 className="mt-3 font-display font-bold text-xl text-slate-900">
                  {c.name}
                </h3>
                <div className="text-xs uppercase tracking-[0.15em] text-slate-500 mt-1 font-semibold">
                  {c.note}
                </div>
                <p className="mt-3 text-sm text-slate-600">{c.hubs}</p>
              </div>
              <div className="mt-4 text-sm text-blue-700 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Explore market <ArrowUpRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
